import type {
  ChecklistItem,
  ChecklistResponse,
  RegulationPack,
  RegulationPackAssessment,
} from '../types';

interface AssessmentApiClient {
  put(url: string, body: unknown): Promise<{ data: RegulationPackAssessment }>;
  get(url: string): Promise<{ data: ChecklistResponse }>;
}

interface SaveRegulationPackAssessmentOptions {
  client: AssessmentApiClient;
  projectId: string;
  pack: RegulationPack;
  inputs: Record<string, boolean>;
  onAssessmentSaved: (assessment: RegulationPackAssessment) => void;
  onChecklistRefreshed: (items: ChecklistItem[]) => void;
}

export async function saveRegulationPackAssessment({
  client,
  projectId,
  pack,
  inputs,
  onAssessmentSaved,
  onChecklistRefreshed,
}: SaveRegulationPackAssessmentOptions): Promise<{
  refreshError: unknown | null;
}> {
  const assessment = await client.put(
    `/api/projects/${projectId}/regulation-packs/${pack}/assessment`,
    { inputs }
  );
  onAssessmentSaved(assessment.data);

  try {
    const checklist = await client.get(`/api/projects/${projectId}/checklist`);
    onChecklistRefreshed(checklist.data.checklistItems);
    return { refreshError: null };
  } catch (refreshError) {
    return { refreshError };
  }
}
